<template>
<div>

  <v-tabs v-model="tab" @change="resumeSubscription(tab)" class="pl-4">
    <v-tabs-slider></v-tabs-slider>
    <v-tab v-for="(s, index) in sArr" :key="index" :href="'#'+s.name" class="primary--text text-capitalize">
            <span :style="`color:${IDS.TripStatusColor[s.status[0]]}`">
                {{ s.label }} ({{ $data[s.name + 'Count']}})
            </span>
    </v-tab>
  </v-tabs>

  <v-card height="40" class="elevation-0 px-6 my-6">
    <v-row>
      <date-range-picker :ranges="dateOptions" class="ml-1 text-body-1" :autoApply="true" opens="right" ref="picker" v-model="date">
        <div class="d-flex " slot="input" slot-scope="picker" style="height: 28px; align-items: center">
          <v-icon class="material-icons mr-2" style="font-size: 20px">mdi-calendar-range-outline</v-icon>
          <template v-if="moment(picker.startDate).format('YYYY-MM-DD')!==moment(picker.endDate).format('YYYY-MM-DD')">
            {{ dateFormatter(picker.startDate) }} - {{ dateFormatter(picker.endDate) }}
          </template>
          <template v-else>{{ dateFormatter(picker.startDate) }}</template>
        </div>
      </date-range-picker>
      <v-spacer/>
      <v-col class="pa-0" cols="auto">
        <v-autocomplete dense clearable :items="routes" outlined
                        v-model="selectedRoute" item-text="name" item-value="id" label="Route"/>
      </v-col>
      <v-col class="pa-0 ml-4" cols="auto">
        <v-text-field dense clearable label="Search By Trip or Route" outlined @input="onSearch"/>
      </v-col>
    </v-row>
  </v-card>

  <v-tabs-items v-model="tab" class="px-4">
    <v-tab-item v-for="(s, index) in sArr" :key="index" :value="s.name">
      <v-data-table :headers="headers[s.name]" :loading="$data[s.name+'Options'].loading"
                    :footerProps="footerProps" class="elevation-0 trips-table" fixed-header height="calc(100vh - 270px)"
                    :items="$data[s.name]" :server-items-length="$data[s.name+'Count']" @click:row="openTripDetail"
                    :sort-by.sync="$data[s.name+'Options'].sortBy" :sort-desc.sync="$data[s.name+'Options'].sortDesc"
                    :options.sync="$data[s.name+'Options']" @update:options="onUpdateOptions">
        <template v-slot:no-data>No Trips Available</template>
        <template v-slot:no-results>No Trips Available</template>
        <template v-slot:item.status="{item}">
          <v-chip label outlined :color="IDS.TripStatusColor[item.statusId]">{{item.TripStatus.title}}</v-chip>
        </template>
        <template v-slot:item.pilotSalesman="{item}"> {{item.CreatedBy.name}}</template>
        <template v-slot:item.routeName="{item}"> {{item.Route.name}}</template>
        <template v-slot:item.visitedShopCount="{item}"> {{item.visitedShops.aggregate.count +'/'+ item.totalShops.aggregate.count}}</template>
        <template v-slot:item.created_at="{ item }">{{ moment(item.created_at).format('DD MMM YYYY hh:mm A') }}</template>
        <template v-slot:item.dispatched_at="{ item }">{{ moment(item.dispatched_at).format('DD MMM YYYY hh:mm A') }}</template>
        <template v-slot:item.delivered_at="{ item }">{{ moment(item.delivered_at).format('DD MMM YYYY hh:mm A') }}</template>
        <template v-slot:item.started_at="{ item }">{{ item.started_at?moment(item.started_at).format('DD MMM YYYY hh:mm A'):'-' }}</template>
        <template v-slot:item.completed_at="{ item }">{{ item.completed_at?moment(item.completed_at).format('DD MMM YYYY hh:mm A'):'-' }}</template>
        <template v-slot:item.action="{item}">
          <v-menu offset-y>
            <template v-slot:activator="{ on }"><v-btn color="primary" dark v-on="on">Manage Status</v-btn></template>
            <v-list>
              <v-list-item v-for="(st, index) in statusOptions[item.statusId]" :key="index" @click="openStatusMenu({...item, selectedStatusId:st.id})">
                <v-list-item-title>{{ st.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-tab-item>
  </v-tabs-items>

  <PreOrderTripDetail :tripId.sync="tripId" :dialog.sync="tripDetailDialog" @openStatusMenu="openStatusMenu"/>
  <ChangeTripStatus :tripId="tripId" :dialog.sync="statusMenu" :selectedStatusId="selectedStatusId"/>
  <Snackbar :toaster="toaster"/>
</div>
</template>

<script>
import {IDS} from "../../Constants/IDS";
import Constants, {dateOptions} from "../../Constants/Constants";
import {generate_FETCH_PRE_ORDER_TRIPS, generate_SUBSCRIBE_PRE_ORDER_TRIPS_COUNT} from "../../graphql/subscriptions/PreOrderTrips";
import moment from "moment";
import {debounce} from 'lodash';
import Snackbar from "../../components/Common/Snackbar";
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import {GET_ROUTES_BY_ORG_ID} from "../../graphql/queries/Routes";
import PreOrderTripDetail from "./PreOrderTripDetail";
import ChangeTripStatus from "./ChangeTripStatus";
let sArr = [
  {name: 'ongoingTrips', status: [IDS.TripStatus.NotStarted, IDS.TripStatus.InProgress, IDS.TripStatus.Paused], label: 'Ongoing Trips'},
  {name: 'completedTrips', status: [IDS.TripStatus.Completed], label: 'Completed Trips'},
  {name: 'dispatchedTrips', status: [IDS.TripStatus.Dispatched], label: 'Dispatched Trips'},
  {name: 'deliveredTrips', status: [IDS.TripStatus.Delivered], label: 'Delivered Trips'}
];
let qObj = {}, sObj = {}, options = {page: 1, loading:true, itemsPerPage: 25, offset: 0, limit: 25, sortBy: ['updated_at'], sortDesc: [true]};
function commonVariables(s)  {
  return {
    status: s.status,
    type: 'PRE-ORDER',
    organizationId : this.loggedInUser.organizationId,
    route: this.selectedRoute,
    search: this.search,
    startDate: moment(this.date.startDate, 'YYYY-MM-DD').startOf('day'),
    endDate: moment(this.date.endDate, 'YYYY-MM-DD').endOf('day'),
  }
}
function pageVariables(s) {
  return {
    orderBy: this.prepareSortObject(this[s.name + 'Options'].sortBy, this[s.name + 'Options'].sortDesc),
    offset: this[s.name + 'Options'].offset, limit: this[s.name + 'Options'].limit
  }
}

sArr.forEach(s => {
 /* qObj[s.name] = {                                                          // Smart Query
    query() {return generate_FETCH_PRE_ORDER_TRIPS(s.name)},
    skip() {return s.name !== 'ongoingTrips'},
    fetchPolicy: 'network-only',
    variables() { return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
    subscribeToMore: {
      document() {return generate_FETCH_PRE_ORDER_TRIPS(s.name, 'subscription')},
      variables() {return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
      updateQuery: function(previousQueryResult, {subscriptionData: {data}}) { this[s.name] = data[s.name]; }
    },
    result({data}) { this[s.name] = data[s.name]; },
  }; */
  sObj[s.name] = {
    query() {return generate_FETCH_PRE_ORDER_TRIPS(s.name, 'subscription')},
    skip() {return s.name !== 'ongoingTrips'},
    variables() { return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
    result({data}) { this[s.name] = data[s.name]; this[s.name + 'Options'].loading = false; },
  };
  sObj[s.name + 'Count'] = {
    query() { return generate_SUBSCRIBE_PRE_ORDER_TRIPS_COUNT(s.name + 'Count') },
    variables() { return {...commonVariables.call(this, s)}},
    result({data}) { this[s.name + 'Count'] = data[s.name + 'Count'].aggregate.count },
  };
});
export default {
  name: "PreOrderTrips",
  components: {ChangeTripStatus, PreOrderTripDetail, Snackbar, DateRangePicker},
  apollo: {
    $subscribe: {...sObj},
    ...qObj,
    routes: {
      query: GET_ROUTES_BY_ORG_ID, fetchPolicy: 'network-only',
      skip () { return !this.loggedInUser },
      variables () { return { orgId: this.loggedInUser.organizationId } }
    },
  },
  data(){
    return{
      loggedInUser: JSON.parse(localStorage.user),
      IDS, dateOptions,
      moment, Constants,
      tab: 'ongoingTrips',
      sArr: sArr,
      search: '%%',
      ...sArr.reduce((ac, s) => {ac[s.name] = []; ac[s.name + 'Count'] = 0; ac[s.name + 'Options'] = {...options}; return ac}, {}),    // newOrders: []
      columns: [
        {text: 'Trip ID', value: 'tripId', width: 150, sortable:false},
        { text: 'Pilot Salesman', value: 'pilotSalesman', sortable:false},
        { text: 'Route Name', value: 'routeName', width:130},
        { text: 'No of Visited out of total Shops', value: 'visitedShopCount', width:130, sortable:false},
        { text: 'Created On', value: 'created_at', sortable:true },

      ],
      footerProps: {'items-per-page-options': [25, 100, 150, 200, -1]},
      date: { startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD') },
      permissions: {},
      statusMenu: false,
      selectedTrip: {},
      menuPositionX: 0,
      menuPositionY: 0,
      headers: {},
      tripDetailDialog: false,
      tripId: null,
      statusId: null,
      toaster: {},
      routes: [],
      selectedRoute: null,
      statusOptions: {
        [IDS.TripStatus.Completed]: [{id:IDS.TripStatus.Dispatched, name:'Dispatched'}, {id:IDS.TripStatus.Delivered, name:'Delivered'}],
        [IDS.TripStatus.Dispatched]: [{id:IDS.TripStatus.Delivered, name:'Delivered'}],
      },
      selectedStatusId: null
    }
  },
  methods:{
    prepareSortObject([sortBy], [order]) {
      order = order ? 'desc' : 'asc';
      if (['updated_at', 'created_at'].includes(sortBy)) return {[sortBy]: order};
      if (sortBy === 'routeName') return {Route: {name: order}};
      return null
    },
    async resumeSubscription(tab) {
      setTimeout(() => this.$apollo.subscriptions[tab].skip = false, 500)
    },
    onUpdateOptions(val) {
      if (val.itemsPerPage === -1) {                                         //'ALL' Rows per page
        this[this.tab + 'Options'].limit = this[this.tab + 'Count'];          //assign total count
        this[this.tab + 'Options'].offset = 0
      } else {
        this[this.tab + 'Options'].limit = val.itemsPerPage;
        this[this.tab + 'Options'].offset = (val.page - 1) * val.itemsPerPage;
      }
    },
    openStatusMenu(row){
      this.tripId = row.id;
      this.selectedStatusId = row.selectedStatusId;
      this.statusMenu = true;
    },
    openTripDetail(row){
      this.tripId = row.id;
      this.tripDetailDialog = true;
    },
    onSearch: debounce(async function (val) {
      if(val && val.length>0 && val.length<3) return;
      this.search = val ? ('%' + val + '%') : '%%';
      sArr.forEach(s => this[s.name + 'Options'] = {...options})          //on search, reset page options
    }, 500),
    getHeaders(){
      sArr.forEach(s => {
        if(['ongoingTrips'].includes(s.name)) this.headers[s.name] = [
          ...this.columns, { text: 'Started On', value: 'started_at', sortable:false },
          { text: 'Status', value: 'status', sortable:false }];
        else if(['completedTrips'].includes(s.name)) this.headers[s.name] = [
          ...this.columns, { text: 'Completed On', value: 'completed_at', sortable:false },
          { text: 'Action', value: 'action', sortable:false }];
        else if(['dispatchedTrips'].includes(s.name)) this.headers[s.name] = [
          ...this.columns, { text: 'Dispatched On', value: 'dispatched_at', sortable:false },
          { text: 'Action', value: 'action', sortable:false }];
        else if(['deliveredTrips'].includes(s.name)) this.headers[s.name] = [
          ...this.columns, { text: 'Delivered On', value: 'delivered_at', sortable:false }];
        else  this.headers[s.name] = this.columns
      });
    },
    showToaster (data) { this.toaster = data },
  },
  beforeMount () {
    // this.permissions = this.$store.getters.permissionByScreen('Distributors');
    this.getHeaders();
  },
}
</script>

<style scoped>
/deep/ tr:hover {
  cursor: pointer !important;
}
</style>